<template>
  <div class="container bg-white" id="ganti-rugi">
    <div class="row">
      <div class="col-xs-18">
        <h3>{{ $t('tos.gantiRugi.title') }}</h3>
        <div class="divider"></div>
        <p>{{ $t('tos.gantiRugi.line1') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'definisi',
};
</script>
